import styled from '@emotion/styled';
import { Icon } from 'src/components-dummy';

export const MenuItemIconStyled = styled(Icon)`
  margin-right: 12px;
`;
